import { call, put, select, takeLatest } from 'redux-saga/effects'
import { OptionsService } from '../services/options.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setRelationshipOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getRelationshipOptions])
    const { entity } = response
    const noneOption = {
      id: 0,
      name: 'None',
    }

    if (entity) yield put(actions.setRelationshipOptions([noneOption, ...entity]))
    else yield put(actions.setRelationshipOptions([]))
  } catch (e) {
    yield put(throwPcrException(`setDestinationBasisOptions() error: ${e}`))
  }
}
export function* setRelationshipOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setRelationshipOptions)
}
